import { BaseEditViewStore } from "core/stores";
import { TrackingCaseDocumentFieldValueEditForm } from "application/tracking-case/forms";
import { TrackingCaseDocumentFieldValueService } from "application/tracking-case/services";
import { observable, action } from "mobx";

class TrackingCaseDocumentFieldValueEditModalStore extends BaseEditViewStore {
    @observable.ref accessor fieldValue = null;

    constructor(rootStore, componentProps) {
        const service = new TrackingCaseDocumentFieldValueService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: "trackingCaseDocumentFieldValueModal",
            id: componentProps.modalParams.data.id,
            actions: {
                get: async id => {
                    const response = await service.get(id, {embed: "documentFormField,documentFormField.documentFormFieldType" });

                    // #region Parsing field types 

                    switch(response.data.documentFormField.documentFormFieldType.abrv){
                        case "check": response.data.value = !response.data.value ? false : response.data.value.toLowerCase() == "true"; break;
                    }

                    //#endregion Parsing field types

                    this.fieldValue = response.data.documentFormField;

                    this.form.update(response.data);
                    return response.data;
                },
                update: async resource => {
                    const response = await service.update(resource);
                    return response.data;
                }
            },
            errorActions: {
                onUpdateError: ({ error }) => {
                    rootStore.notificationStore.error('TRACKING_CASE_DOCUMENT_FIELD_VALUE.EDIT.ERROR', error);
                }
            },
            FormClass: TrackingCaseDocumentFieldValueEditForm,
        });

        this.componentProps = componentProps;
        this.componentData = componentProps && componentProps.modalParams.data;
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.update({
                id: this.id,
                ...resource
            });

            this.form.setFieldsDisabled(false);

            if (this.componentData == null) {
                await this.rootStore.routerStore.goBack();
            } else
            {
                this.componentProps.modalParams.close();
                this.componentProps.modalParams.data.fetchTable();
            }

            await setTimeout(() => this.notifySuccessCreate(), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onCreateError(err);
        }
    }
}

export default TrackingCaseDocumentFieldValueEditModalStore;